import { NgModule } from '@angular/core';

import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {
    faAlignCenter,
    faAlignJustify,
    faAlignLeft,
    faAlignRight,
    faBaby,
    faBan,
    faBars,
    faBell,
    faBold,
    faBook,
    faBorderNone,
    faCheck,
    faChevronCircleLeft,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faChevronUp,
    faClock,
    faCog,
    faCopy,
    faDownload,
    faEllipsisH,
    faEllipsisV,
    faEnvelope,
    faEnvelopeOpenText,
    faExternalLinkAlt,
    faExternalLinkSquareAlt,
    faEye as faEyeSolid,
    faEyeSlash,
    faFileAlt,
    faFileInvoice,
    faFilePdf,
    faFont,
    faGlobeAmericas,
    faHistory,
    faHome,
    faIndent,
    faInfo,
    faInfoCircle,
    faItalic,
    faLayerGroup,
    faLink,
    faListOl,
    faListUl,
    faMailBulk,
    faMinusCircle,
    faOutdent,
    faPaintRoller,
    faPaperclip,
    faPen,
    faPlay,
    faPlayCircle,
    faPlus,
    faPlusCircle,
    faPowerOff,
    faQuestion,
    faQuestionCircle,
    faRedo,
    faRedoAlt,
    faRemoveFormat,
    faSave,
    faSearch,
    faSignature,
    faSitemap,
    faSnowflake,
    faSpinner,
    faStrikethrough,
    faSubscript,
    faSuperscript,
    faUpload,
    faTable,
    faTimesCircle,
    faTint,
    faTrash,
    faTrashAlt,
    faUnderline,
    faUndo,
    faUndoAlt,
    faUnlink,
    faUserCog,
    faUserPlus,
    faUsers,
    faVial,
    faWindowMaximize,
    faXmark
} from '@fortawesome/free-solid-svg-icons';
import {
    faClone,
    faEye,
    faFilePdf as farFilePdf,
    faImage as faImageRegular
} from '@fortawesome/free-regular-svg-icons';

@NgModule({
    imports: [FontAwesomeModule]
})
export class AppIconsModule {
    constructor(library: FaIconLibrary) {
        library.addIcons(
            faBan,
            faXmark,
            faUserPlus,
            faUpload,
            faTrash,
            faPlusCircle,
            faUndo,
            faBold,
            faItalic,
            faFont,
            faListOl,
            faListUl,
            faUnderline,
            faLink,
            faStrikethrough,
            faRedo,
            faRemoveFormat,
            faGlobeAmericas,
            faFilePdf,
            faInfo,
            faChevronCircleLeft,
            faPlus,
            faChevronDown,
            faChevronUp,
            faTimesCircle,
            faFileAlt,
            faCopy,
            faBook,
            faUserCog,
            faUsers,
            faSitemap,
            faEnvelopeOpenText,
            faFileInvoice,
            faChevronRight,
            faChevronLeft,
            faExternalLinkAlt,
            faQuestion,
            faBars,
            faSearch,
            faQuestionCircle,
            faCheck,
            faSignature,
            faPen,
            faPowerOff,
            faTrashAlt,
            faBaby,
            faClone,
            faEye,
            faDownload,
            faPaperclip,
            faInfoCircle,
            faUndoAlt,
            faSuperscript,
            faAlignCenter,
            faAlignJustify,
            faAlignLeft,
            faAlignRight,
            faPaintRoller,
            faOutdent,
            faIndent,
            faRedoAlt,
            faSubscript,
            faVial,
            farFilePdf,
            faEnvelope,
            faSpinner,
            faLayerGroup,
            faTable,
            faImageRegular,
            faEyeSolid,
            faWindowMaximize,
            faMinusCircle,
            faTint,
            faUnlink,
            faCog,
            faHome,
            faEyeSlash,
            faEllipsisV,
            faBell,
            faEllipsisH,
            faExternalLinkSquareAlt,
            faPlay,
            faHistory,
            faSave,
            faPlayCircle,
            faSnowflake,
            faClock,
            faMailBulk,
            faBorderNone
        );
    }
}
